import { FC, ReactNode, useState, useRef } from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { WbTooltip } from '../WbTooltip';
import { useOverflowingElement } from '../../hooks/useOverflowingElement';
import { WbButton } from '../WbButton';

const useStyles = makeStyles(() =>
  createStyles({
    truncated: {
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 3,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-inline-box',
      wordBreak: 'break-word',
    },
  }),
);

export interface ShowMoreElementProps {
  children?: ReactNode;
  maxLines?: number;
  showMoreButton?: boolean;
}

export const WbShowMoreElement: FC<ShowMoreElementProps> = ({
  children,
  maxLines,
  showMoreButton = false,
}) => {
  const classes = useStyles();
  const ref = useRef<HTMLSpanElement>(null);
  const isOverflowing = useOverflowingElement(ref);
  const [showMore, setShowMore] = useState(false);

  const tooltipTitle =
    typeof children === 'string' && isOverflowing ? children : '';

  return (
    <>
      <WbTooltip title={tooltipTitle}>
        <span
          className={!showMore ? classes.truncated : ''}
          ref={ref}
          style={
            !showMore && maxLines ? { WebkitLineClamp: maxLines } : undefined
          }
        >
          {children}
        </span>
      </WbTooltip>

      {showMoreButton && (isOverflowing || showMore) && (
        <>
          <WbButton
            variant="text"
            label={!showMore ? 'More' : 'Less'}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setShowMore(v => !v);
            }}
          />
        </>
      )}
    </>
  );
};
